import { Container, Paper, Typography } from "@mui/material"
import { ResumenEstudiante } from "./ResumenEstudiante"
import { TablaAyudGes } from "./TablaAyudGes"


export const ActividadesGestion: React.FC = () =>{
    return(
        <Paper  elevation={3} sx={{ padding: 2, marginBottom: 3}}>
            <Container sx={{display: "flex",             
                            flexDirection: "column", alignItems:"center"}}>
                <Typography
                    variant="h5"
                    sx={{
                    fontWeight: "bold",
                    color: "#243165",
                    marginBottom: "24px",
                    
                    }}
                >
                    Actividades de ayudantías de gestión de docencia(Varias)
                </Typography>
            </Container>
    
            <Container>
                <ResumenEstudiante />
            </Container>

            <Container>
                <TablaAyudGes/>
            </Container>

        </Paper>
    )
}